// 디자인 토큰 — chl.ee(hiddenest.dev)에서 실측한 값 기준.
// 색은 Tailwind neutral 스케일, 강조는 sky/blue 최소 사용.
const theme = {
  colors: {
    background: "#FFFFFF",
    backgroundAlt: "#FAFAFA", // neutral-50
    backgroundMuted: "#F5F5F5", // neutral-100
    border: "#E5E5E5", // neutral-200 — 인용문·표 경계
    borderLight: "#F5F5F5", // neutral-100 — 목록 구분선
    textStrong: "#171717", // neutral-900 — 제목
    text: "#404040", // neutral-700 — 본문
    textSoft: "#525252", // neutral-600 — 목록 요약
    textMeta: "#737373", // neutral-500 — 날짜·캡션
    textMuted: "#A1A1A1", // neutral-400 — 푸터·비활성
    textFaint: "#D4D4D4", // neutral-300 — 앵커 기호·틱
    selection: "#DFF2FE", // sky-100
    link: "#38618C", // 채도를 낮춘 청색 — 흑백 지면에서 링크만 살짝 떠오르게
    linkHover: "#24405F",
    linkUnderline: "#B9CADB",
    codeBlock: "#262626", // neutral-800
    codeInline: "#F5F5F5",
    codeBorder: "#262626",
    codeScrollbar: "#404040",
  },
  fonts: {
    body: "'Asta Sans', -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', 'Segoe UI', sans-serif",
    heading:
      "'Asta Sans', -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', 'Segoe UI', sans-serif",
    code: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
  },
  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
  },
  layout: {
    maxWidth: "768px", // = Tailwind breakpoint-md 48rem
    contentMaxWidth: "768px",
    headerHeight: "80px", // = h-20
    gutter: "1.5rem", // = px-6
  },
  radii: {
    sm: "4px",
    md: "6px",
    lg: "12px",
    xl: "16px", // rounded-2xl — 커버 이미지
  },
  // 모든 상태 전환은 짧고 한 방향으로만. 0.15s ease-out.
  motion: {
    fast: "0.15s cubic-bezier(0, 0, 0.2, 1)",
    base: "0.25s cubic-bezier(0, 0, 0.2, 1)",
  },
  shadows: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.04)",
    md: "0 4px 12px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 30px rgba(0, 0, 0, 0.08)",
    overlay: "0 25px 50px rgba(0, 0, 0, 0.18)",
  },
};

export default theme;
